openExternalLinksInNewTab();
buildEmailLinks('a.email');
tooltips.init();
ssm.addState({
  id: 'mobile', query: '(max-width: 767px)', onEnter: function onEnter() {
    clipToEdgeOnOverflow.apply('.tdi--text-overflow-wrapper')
  },
  onResize: function onResize() {
    clipToEdgeOnOverflow.apply('.tdi--text-overflow-wrapper')
  },
  onLeave: function onLeave() {
    clipToEdgeOnOverflow.undo()
  }
});
var rows = $('.toggle-table').find('tr');
toggleRows(rows);

function toggleRows(rows) {
  $(rows).each(function() {
  if($(this).find('td').length != 0) {
    $(this).toggle('slow');
  }
  })
}

$('.toggle-table').on('click', function() {
  toggleRows($(this).find('tr'));
})
//# sourceMappingURL=main.js.map